"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mountIsland_1 = require("../mountIsland");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var Alert_1 = __importDefault(require("@mui/material/Alert"));
var Lang_js_1 = require("../Lang.js");
var NAVY = '#1c1c3c';
var STATUS_LABELS = {
    active: { label: 'Active', color: '#1a6e1e', bg: 'rgba(25,148,32,0.08)' },
    past_due: { label: 'Past Due', color: '#b45309', bg: 'rgba(245,158,11,0.10)' },
    canceled: { label: 'Canceled', color: '#9e3a3a', bg: 'rgba(211,47,47,0.08)' },
    trialing: { label: 'Trial', color: '#0369a1', bg: 'rgba(3,105,161,0.08)' },
    incomplete: { label: 'Incomplete', color: '#888', bg: 'rgba(0,0,0,0.06)' },
};
function formatDate(d) {
    if (!d)
        return '—';
    var _a = d.split('-').map(Number), y = _a[0], m = _a[1], day = _a[2];
    return new Date(y, m - 1, day).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}
// Plans are stored with a language suffix (e.g. "TWI Monthly (English)") so admin
// can disambiguate en/es rows at a glance; the customer-facing display drops it
// because the subscription grants access to all content regardless of language.
function cleanPlanName(name) {
    return (name !== null && name !== void 0 ? name : '').replace(/\s*\((?:English|Spanish)\)\s*$/, '');
}
var TwiPlansPage = function () {
    var _a, _b, _c;
    var container = document.getElementById('twi-plans-page');
    var dataset = (container === null || container === void 0 ? void 0 : container.dataset) || {};
    var showPortalNote = dataset.portalNote === '1';
    // Controller redirects carry outcome codes as query params (no session store on
    // Lambda, so Laravel flash messages never survive a redirect in this app).
    var noticeCode = new URLSearchParams(window.location.search).get('notice');
    var NOTICES = {
        checkout_failed: { severity: 'error', message: (0, Lang_js_1.__)('We could not start the checkout process and no charge has been made. Please try again — if the problem continues, please contact support.') },
        plan_unavailable: { severity: 'error', message: (0, Lang_js_1.__)('That plan is not available.') },
        not_eligible: { severity: 'error', message: (0, Lang_js_1.__)('The Seminar Leader plan is only available to approved seminar leaders.') },
        swap_failed: { severity: 'error', message: (0, Lang_js_1.__)('We could not change your plan. Please try again or contact support.') },
        plan_updated: { severity: 'success', message: (0, Lang_js_1.__)('Your plan has been updated.') },
    };
    var notice = noticeCode ? NOTICES[noticeCode] : undefined;
    var subscription = { active: false, plan_slug: null, plan_name: null, stripe_status: null, billing_amount: null, next_billing_date: null, start_date: null };
    var plans = [];
    try {
        if (dataset.subscription)
            subscription = JSON.parse(dataset.subscription);
        if (dataset.plans)
            plans = JSON.parse(dataset.plans);
    }
    catch (e) {
        console.warn('TwiPlansPage: parse error', e);
    }
    var _d = (0, react_1.useState)(null), hoveredPlan = _d[0], setHoveredPlan = _d[1];
    var csrfToken = (_b = (_a = document.querySelector('meta[name="csrf-token"]')) === null || _a === void 0 ? void 0 : _a.content) !== null && _b !== void 0 ? _b : '';
    var statusInfo = subscription.stripe_status ? (_c = STATUS_LABELS[subscription.stripe_status]) !== null && _c !== void 0 ? _c : STATUS_LABELS.incomplete : null;
    return (react_1.default.createElement(Box_1.default, { sx: { p: 2, maxWidth: '1200px', mx: 'auto', backgroundColor: '#f5f6f8' } },
        notice && (react_1.default.createElement(Alert_1.default, { severity: notice.severity, sx: { mb: 2 } }, notice.message)),
        showPortalNote && (react_1.default.createElement(Alert_1.default, { severity: "info", sx: { mb: 2 } }, (0, Lang_js_1.__)('Subscription management (cancel, update payment method, billing history) is handled via the Stripe Customer Portal — the button below will redirect you there once fully wired up.'))),
        react_1.default.createElement(Box_1.default, { sx: { mb: 3 } },
            react_1.default.createElement(Typography_1.default, { component: "a", href: "/app/twi", sx: { display: 'block', mb: 1.5, fontSize: '14px', fontWeight: 600, color: NAVY, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } } },
                "\u2190 ",
                (0, Lang_js_1.__)('Back to That Which Is')),
            react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h1", sx: { mt: 1.5, fontSize: '26px', fontWeight: 700, color: NAVY, lineHeight: 1.2 } }, (0, Lang_js_1.__)('That Which Is — Subscription Plans')),
            react_1.default.createElement(Typography_1.default, { sx: { mt: 1, fontSize: '15px', color: '#555', lineHeight: 1.6 } }, (0, Lang_js_1.__)('Stream thousands of hours of talks, seminars, and meditations from John-Roger and John Morton.'))),
        subscription.active && (react_1.default.createElement(Paper_1.default, { elevation: 0, sx: {
                mb: 3, p: '18px 24px', borderRadius: 2,
                backgroundColor: '#fff',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                border: "2px solid rgba(25,148,32,0.25)",
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                flexWrap: 'wrap', gap: 2,
            } },
            react_1.default.createElement(Box_1.default, null,
                react_1.default.createElement(Box_1.default, { sx: { display: 'flex', alignItems: 'center', gap: 1.5, mb: 0.5 } },
                    react_1.default.createElement(Typography_1.default, { sx: { fontWeight: 700, fontSize: '16px', color: NAVY } }, (0, Lang_js_1.__)(cleanPlanName(subscription.plan_name))),
                    statusInfo && (react_1.default.createElement(Box_1.default, { sx: {
                            px: '10px', py: '3px', borderRadius: '12px',
                            backgroundColor: statusInfo.bg, color: statusInfo.color,
                            fontSize: '12px', fontWeight: 700,
                        } }, (0, Lang_js_1.__)(statusInfo.label)))),
                react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: 3, flexWrap: 'wrap' } },
                    subscription.billing_amount && (react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', color: '#555' } },
                        react_1.default.createElement("strong", null,
                            (0, Lang_js_1.__)('Amount'),
                            ":"),
                        " $",
                        subscription.billing_amount,
                        "/mo")),
                    subscription.next_billing_date && (react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', color: '#555' } },
                        react_1.default.createElement("strong", null,
                            (0, Lang_js_1.__)('Next Billing'),
                            ":"),
                        " ",
                        formatDate(subscription.next_billing_date))),
                    subscription.start_date && (react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', color: '#555' } },
                        react_1.default.createElement("strong", null,
                            (0, Lang_js_1.__)('Member Since'),
                            ":"),
                        " ",
                        formatDate(subscription.start_date))))),
            react_1.default.createElement(Box_1.default, { component: "a", href: "/app/twi/subscriptions/portal", sx: {
                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                    backgroundColor: NAVY, color: '#fff', borderRadius: 1.5,
                    px: 3.5, height: '42px', fontSize: '14px', fontWeight: 700,
                    textDecoration: 'none', whiteSpace: 'nowrap',
                    '&:hover': { backgroundColor: '#2a2a4c', textDecoration: 'none', color: '#fff' },
                } }, (0, Lang_js_1.__)('Manage Subscription')))),
        react_1.default.createElement(Box_1.default, { sx: {
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' },
                gap: 2,
                mb: 3,
            } }, plans.map(function (plan) {
            var isCurrent = subscription.plan_slug === plan.slug;
            var isHovered = hoveredPlan === plan.slug;
            return (react_1.default.createElement(Paper_1.default, { key: plan.slug, elevation: 0, onMouseEnter: function () { return setHoveredPlan(plan.slug); }, onMouseLeave: function () { return setHoveredPlan(null); }, sx: {
                    p: '28px',
                    borderRadius: 2,
                    border: "2px solid ".concat(isCurrent ? 'rgba(25,148,32,0.4)' : isHovered ? NAVY : '#e0e0e0'),
                    backgroundColor: '#fff',
                    boxShadow: isHovered ? '0 4px 16px rgba(0,0,0,0.10)' : '0 1px 3px rgba(0,0,0,0.06)',
                    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                } },
                isCurrent && (react_1.default.createElement(Box_1.default, { sx: {
                        position: 'absolute', top: '-1px', right: '20px',
                        backgroundColor: '#1a6e1e', color: '#fff',
                        fontSize: '11px', fontWeight: 700, px: '12px', py: '4px',
                        borderRadius: '0 0 6px 6px', letterSpacing: '0.5px',
                    } }, (0, Lang_js_1.__)('CURRENT PLAN'))),
                plan.role === 'svod_seminar_leader' && (react_1.default.createElement(Box_1.default, { sx: {
                        position: 'absolute', top: '-1px', left: '20px',
                        backgroundColor: '#7c3aed', color: '#fff',
                        fontSize: '11px', fontWeight: 700, px: '12px', py: '4px',
                        borderRadius: '0 0 6px 6px', letterSpacing: '0.5px',
                    } }, (0, Lang_js_1.__)('SEMINAR LEADERS'))),
                react_1.default.createElement(Box_1.default, { sx: { mb: 2.5 } },
                    react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h2", sx: { m: 0, fontSize: '20px', fontWeight: 700, color: NAVY } }, (0, Lang_js_1.__)(cleanPlanName(plan.name))),
                    react_1.default.createElement(Box_1.default, { sx: { mt: 1.5, display: 'flex', alignItems: 'baseline', gap: 0.5 } },
                        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '36px', fontWeight: 800, color: NAVY, lineHeight: 1 } },
                            "$",
                            plan.amount.toFixed(2)),
                        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '15px', color: '#666', fontWeight: 500 } },
                            "/",
                            plan.interval)),
                    react_1.default.createElement(Typography_1.default, { sx: { mt: 0.5, fontSize: '12px', color: '#888' } }, (0, Lang_js_1.__)('Cancel anytime · Billed monthly'))),
                react_1.default.createElement(Box_1.default, { sx: { flex: 1, mb: 3 } }, plan.features.map(function (f, i) { return (react_1.default.createElement(Box_1.default, { key: i, sx: { display: 'flex', alignItems: 'flex-start', gap: 1.5, mb: 1 } },
                    react_1.default.createElement(Box_1.default, { sx: {
                            width: '18px', height: '18px', borderRadius: '50%',
                            backgroundColor: 'rgba(25,148,32,0.12)', color: '#1a6e1e',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            flexShrink: 0, mt: '1px', fontSize: '11px', fontWeight: 700,
                        } }, "\u2713"),
                    react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', color: '#333', lineHeight: 1.5 } }, (0, Lang_js_1.__)(f)))); })),
                isCurrent ? (react_1.default.createElement(Box_1.default, { component: "a", href: "/app/twi/subscriptions/portal", sx: {
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        height: '46px', borderRadius: '6px',
                        border: "2px solid ".concat(NAVY), color: NAVY,
                        fontSize: '14px', fontWeight: 700, textDecoration: 'none',
                        '&:hover': { backgroundColor: 'rgba(28,28,60,0.04)', textDecoration: 'none', color: NAVY },
                    } }, (0, Lang_js_1.__)('Manage Subscription'))) : subscription.active ? (
                // Existing subscriber switching plans — swap the price in place (no new
                // checkout, no immediate charge). The new price applies next billing cycle.
                react_1.default.createElement(Box_1.default, { component: "form", method: "POST", action: "/app/twi/subscriptions/swap", sx: { m: 0 } },
                    react_1.default.createElement("input", { type: "hidden", name: "_token", value: csrfToken }),
                    react_1.default.createElement("input", { type: "hidden", name: "plan", value: plan.slug }),
                    react_1.default.createElement(Box_1.default, { component: "button", type: "submit", sx: {
                            width: '100%', cursor: 'pointer', border: 'none',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            height: '46px', borderRadius: '6px',
                            backgroundColor: NAVY, color: '#fff',
                            fontSize: '14px', fontWeight: 700, fontFamily: 'inherit',
                            transition: 'background-color 0.2s ease',
                            '&:hover': { backgroundColor: '#2a2a4c' },
                        } }, (0, Lang_js_1.__)('Switch to This Plan')))) : (react_1.default.createElement(Box_1.default, { component: "a", href: "/app/twi/subscribe/checkout?plan=".concat(plan.slug), sx: {
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        height: '46px', borderRadius: '6px',
                        backgroundColor: NAVY, color: '#fff',
                        fontSize: '14px', fontWeight: 700, textDecoration: 'none',
                        transition: 'background-color 0.2s ease',
                        '&:hover': { backgroundColor: '#2a2a4c', textDecoration: 'none', color: '#fff' },
                    } }, (0, Lang_js_1.__)('Subscribe Now')))));
        })),
        react_1.default.createElement(Box_1.default, { sx: {
                p: '14px 18px', borderRadius: 2,
                backgroundColor: 'rgba(28,28,60,0.03)',
                border: '1px solid rgba(28,28,60,0.08)',
            } },
            react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', color: '#555', lineHeight: 1.6 } },
                react_1.default.createElement("strong", null,
                    (0, Lang_js_1.__)('Billing note'),
                    ":"),
                ' ',
                (0, Lang_js_1.__)('Subscriptions are billed monthly via Stripe. You can cancel anytime and will retain access through the end of your billing period. For billing questions, contact support or use the Stripe Customer Portal to view your invoices.')))));
};
var twiPlansEl = document.getElementById('twi-plans-page');
if (twiPlansEl) {
    (0, mountIsland_1.mountIsland)(twiPlansEl, react_1.default.createElement(TwiPlansPage, null));
}
exports.default = TwiPlansPage;
